import { api } from 'src/api';
import type { TBankAuthResponse } from '@lt/api/dist/methods/client/types';
import type { CLIENT } from '@lt/api/dist/types/client';
import { sendCommonEvents } from 'src/helpers/sendCommonEvents';
import { pushAuthSuccessful } from '../analytics';
import { AuthMethodsForAnalytics } from '../types';

export const handleTbankWebviewAuth = async (
  code: string,
  state: string,
  session_state: string,
  onSuccess: (client: CLIENT) => void,
  onError: (error: unknown) => void,
): Promise<void> => {
  try {
    const tokenPayload: TBankAuthResponse = {
      code,
      state,
      session_state,
      redirect_url: `${window.location.origin}/login/tbank`,
    };

    const isSeamless = !!sessionStorage.getItem('is_seamless_tbank');
    const provider = isSeamless ? 'tbank_link' : 'tbank';

    const authResponse = await api.postClientAuth({
      token: tokenPayload,
      provider,
      use_cookies: true,
    });

    if (authResponse.success) {
      onSuccess(authResponse.client);
      pushAuthSuccessful(AuthMethodsForAnalytics.TBank);
      sendCommonEvents('oauth', 'tbank');
    } else {
      // eslint-disable-next-line no-console
      console.error('Tbank Auth failed');
      onError(new Error('TBank auth failed'));
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('TBank auth failed', error);
    onError(error);
  } finally {
    sessionStorage.removeItem('is_seamless_tbank');
  }
};
